/**
 * Reveals the PDP stock line for the selected variant.
 *
 * x-product-selector owns the variant data and reports depth on `variant-selected`; this lives
 * in the add-to-cart block, outside that Preact tree, so the window event is the only bridge.
 */
import { formatStockMessage, matchStockIndicator } from 'libs/helpers/stock-indicators'

const INDICATOR_SELECTOR = '[data-role="pdp-low-stock"]'
const LABEL_SELECTOR = '[data-role="stock-indicator-label"]'

let activeListener = null

function initStockIndicator() {
  /** Editor reloads replace the node, so drop the listener still writing to the old one. */
  if (activeListener) window.removeEventListener('variant-selected', activeListener)
  activeListener = null

  const indicator = document.querySelector(INDICATOR_SELECTOR)
  if (!indicator) return

  const label = indicator.querySelector(LABEL_SELECTOR)

  activeListener = (event) => {
    /** Older dispatchers send a plain Event with no detail — treat that as "nothing to show". */
    const { inventory, available } = event.detail ?? {}
    const tier = available === false ? null : matchStockIndicator(inventory)

    indicator.classList.toggle('hidden', !tier)
    if (!tier) return

    indicator.style.setProperty('--indicator-colour', tier.colour ?? 'currentColor')
    if (label) label.textContent = formatStockMessage(tier.message, Number(inventory))
  }

  window.addEventListener('variant-selected', activeListener)
}

initStockIndicator()
/** The theme editor re-renders product-main, which replaces the node this listener wrote to. */
document.addEventListener('shopify:section:load', initStockIndicator)
